module.exports = __webpack_public_path__ + "static/media/google-play-badge.a011f1b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/site-render/src/AppSection/google-play-badge.svg
// module id = 1055
// module chunks = 1